var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-wrapper nav"},[_c('router-link',{attrs:{"to":{ name: 'PackingList' }}},[_c('span',{staticClass:"material-symbols-outlined"},[_vm._v("arrow_back_ios_new")]),_vm._v("BACK")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }